import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import Select from "react-select";
import { getBusiness } from "../../../redux/business/action";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getAllListUsers, wishListData, wishlistFilter } from "../../../redux/booking/action";
import PhoneInput from 'react-phone-input-2'
import CommonPagination from "../../Common/Pagination/CommonPagination";

const LoadMoreOption = ({ children, innerProps }) => (
    <div 
        style={{
            textAlign: 'center',
            padding: '8px',
            cursor: 'pointer',
            color: '#2684FF',
            backgroundColor: '#f8f9fa'
        }}
        {...innerProps}
    >
        {children || 'Load more...'}
    </div>
);


const AddWishList = () => {
    const users = useSelector((state) => state.bookingSlice?.getUsersList)
    const wishList = useSelector((state) => state.bookingSlice.getWishlist);
    const business = useSelector(({ business: { businesslist } }) => businesslist);
    const wishListFilter = useSelector((state) => state.bookingSlice.getwishFilter);
    const businesslist = business?.businesses;
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const dispatch = useDispatch();
    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const [selectCustomer, setSelectCustomer] = useState([]);
    const [accumulatedDrivers, setAccumulatedDrivers] = useState([]);
    const [paramsList, setParamsList] = useState({
        page: 1,
        search_key:"",
        type:1
    })
    const [params, setParams] = useState({
        page: 1,
        business_id: "",
        customer_id: null,
    });
    const [paramss, setParamss] = useState({
        page: 1,
    });



    const proOptions = accumulatedDrivers?.map((item) => ({
        value: item.id,
        label: item.business_name,
    }));

    const customerOptions = wishListFilter?.map((item) => ({
        value: item.id,
        label: item.first_name,
    }));

    useEffect(() => {
        dispatch(wishListData(params));
    }, [dispatch, params]);

    useEffect(() => {
        dispatch(getAllListUsers(paramss))
    }, [dispatch, paramss])

    useEffect(() => {
        dispatch(getBusiness(paramsList));
    }, [dispatch,paramsList]);

    useEffect(() => {
        if (businesslist) {
            setAccumulatedDrivers(prev => {
                const combined = [...prev, ...businesslist];
                return Array?.from(new Map(combined?.map(item => [item.id, item])).values());
            });
        }
    }, [businesslist]);

    const handleClearData = () => {
        setSearchTerm("");
        setSelectedBusiness(null);
        setSelectedData(null);
        setParams({
            page: 1,
            business_id: "",
            customer_id: "",
        });
        setParamsList({
            page: 1,
            search_key: "",
            type: 1
        });
        setAccumulatedDrivers([]);
        setFilteredData([]);
    };

    const handleChangeProfessional = (selected) => {
        setSelectedBusiness(selected);
        setParams((prev) => ({
            ...prev,
            business_id: selected?.value || "",
        }));
        setParams((prevParams) => ({
            ...prevParams,
            page: 1
        }));
    };

    const handleChageCustomer = (selected) => {
        setSelectCustomer(selected);

    };

    const handelContryCode = (value, data) => {
        formik.setFieldValue('mobile_number', `${value.slice(data.dialCode.length)}`)
        formik.setFieldValue('country_code', `+${data.dialCode}`)
    }

    const formik = useFormik({
        initialValues: {
            mobile_number: "",
            country_code: ""
            // Only track the mobile number
        },
        onSubmit: (values) => {
            // handleSubmit(values);
        },
    });

    useEffect(() => {
        dispatch(wishlistFilter(formik.values.country_code, formik.values.mobile_number,));
    }, [dispatch, formik.values.mobile_number, formik.values.country_code]);

    useEffect(() => {
        setParams((prev) => ({
            ...prev,
            customer_id: selectedData?.id || "",
        }));
    }, [searchTerm,]);

    useEffect(() => {
        setSelectCustomer(null);
        setParams((prev) => ({
            ...prev,
            customer_id: "",
        }));
    }, [formik.values.mobile_number]);
    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);


        if (term.trim() === "") {
            setFilteredData([]);
            setSelectedData(null);

            setParams((prev) => ({
                ...prev,
                customer_id: "",
            }));
            dispatch(wishListData(params));
        } else {
            const results = users?.users.filter(
                (item) =>
                    item.full_name.toLowerCase().includes(term) ||
                    String(item.mobile_number).includes(term)
            );
            setFilteredData(results);
        }
    };

    const handleSelect = (item) => {
        if (!item) return;
        setSelectedData(item);
        setSearchTerm(`${item.full_name}, ${item.mobile_number}`);
        setFilteredData([]);
    };


    const handleMenuScrollToBottom = () => {
        setParamsList(prev => ({
            ...prev,
            page: prev.page + 1
        }));
    };



    const customComponents = {
        MenuList: ({ children, ...props }) => (
            <div {...props}>
                {children}
                {businesslist && businesslist?.length > 0 && (
                    <LoadMoreOption
                        innerProps={{
                            onMouseDown: handleMenuScrollToBottom,
                            onClick: handleMenuScrollToBottom
                        }}
                    >
                        Load More...
                    </LoadMoreOption>
                )}
            </div>
        )
    };

    const handleInputChange = (inputValue) => {
        setParamsList(prev => ({
            ...prev,
            page: 1,
            search_key: inputValue
        }));
        setAccumulatedDrivers([]);
    };

    return (
        <div className="col-md-12 pt-4">


            <div className="row">
              
                <div className="col-md-4 form-group">
                    <label style={{ fontSize: "16px", fontWeight: "bold", color: "#333" }}>Select Customer</label>
                    <input
                        type="search"
                        placeholder="Search Customer"
                        value={searchTerm}
                        onChange={handleSearch}
                        style={{
                            width: "100%",
                            padding: "10px 12px",
                            fontSize: "16px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                            outline: "none",
                            transition: "border-color 0.3s, box-shadow 0.3s",
                        }}
                        className="custom-search-input"
                    />


                    <div className="" style={{ padding: '0 15px', position: "absolute", left: '0', width: "100%", }}>

                        {filteredData.length > 0 ? (
                            <ul
                                style={{
                                    listStyleType: "none",
                                    margin: 0,
                                    padding: 0,
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    background: "white",

                                    zIndex: 1000,
                                    maxHeight: "150px",

                                    overflowY: "auto",
                                }}
                            >
                                {filteredData.map((item) => (
                                    <li
                                        key={item.id}
                                        onClick={() => handleSelect(item)}
                                        style={{
                                            padding: "8px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #f0f0f0",
                                        }}
                                    >
                                        {item.full_name}   {item?.country_code} {item.mobile_number}
                                    </li>
                                ))}
                            </ul>
                        ) : searchTerm.trim() !== "" ? (
                            <div className="dataShow">

                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="col-md-3 form-group">
                    <label>Select Business</label>
                    <Select
                        value={selectedBusiness}
                        onChange={handleChangeProfessional}
                        options={proOptions}
                        placeholder="Select Business"
                        onMenuScrollToBottom={handleMenuScrollToBottom}
                        components={customComponents}
                        isSearchable
            onInputChange={handleInputChange}
                    />
                </div>
                <div className="col-md-3 form-group d-flex justify-content-center flex-column align-items-start">
                    <label className="d-block">&nbsp;</label>
                    <button className='  submit-btn' 
                    onClick={()=>{handleClearData()}}
                    >Clear</button>
                </div>
            </div>
            <CardBody className="table-sec px-0">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Business Name</th>
                            <th scope="col">Customer Name</th>
                            <th scope="col">Mobile Number</th>
                            <th scope="col">Created On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {wishList?.wishlist_items?.length > 0 ? (
                            wishList?.wishlist_items.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1 + (params?.page - 1) * 10}</td>
                                    <td className="w-25">{item?.business_name || ""}</td>
                                    <td>{`${item?.firstname || ""} ${item?.lastname || ""}`}</td>
                                    <td>{`${item?.country_code || ""} ${item?.mobile_number || ""}`}</td>
                                    <td>
                                        {item?.created_on
                                            ? new Date(item.created_on).toLocaleDateString()
                                            : ""}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">
                                    No Wishlist found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <CommonPagination
                    params={params}
                    setParams={setParams}
                    pagination_meta={wishList?.pagination_meta}
                />
            </CardBody>


        </div>
    );
};

export default AddWishList;
